import './polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';

import { store, persistor } from './store/createStore';
import { clearToken } from './store/modules/auth';
import { http } from './helpers/axios';
import { Setup, Login, Dashboard } from './routes';

import './styles/root.css';

const onBeforeLift = () => {};

// Use auth token if available
http.interceptors.request.use(config => {
  const { token } = store.getState().auth;

  if (token) {
    config.headers.authorization = token;
  }

  return config;
});

// https://github.com/axios/axios/issues/266
http.interceptors.response.use(
  config => config,
  err => {
    const res = err.response || {};

    if (res.status === 401 && res.config && !res.config.__isRetryRequest) {
      window.localStorage.clear();
      store.dispatch(clearToken());
      console.log('Redirecting to login...');
    }

    return Promise.reject(err);
  }
);

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor} onBeforeLift={onBeforeLift}>
      <Router>
        <Switch>
          <Route exact path="/login" component={Login} />
          <Route path="/setup" component={Setup} />
          <Route path="/dashboard" component={Dashboard} />

          <Redirect to="/dashboard" />
        </Switch>
      </Router>
    </PersistGate>
  </Provider>,
  document.getElementById('root')
);
